"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customizeGroupName = void 0;
const renderMustacheTemplate_1 = require("./renderMustacheTemplate");
// TODO write tests
const customizeGroupName = (title, probabilities, categoryMarket, competitors) => {
    if (!categoryMarket.shouldCustomizeGroupName) {
        return title;
    }
    const homeCompetitorNames = competitors.homeCompetitors
        .map((c) => c.name)
        .join(', ');
    const awayCompetitorNames = competitors.awayCompetitors
        .map((c) => c.name)
        .join(', ');
    const data = {
        competitor1: homeCompetitorNames,
        competitor2: awayCompetitorNames,
    };
    probabilities.forEach((probability) => {
        probability.parameters.forEach((param) => {
            data[param.type] = param.value;
        });
    });
    return (0, renderMustacheTemplate_1.renderMustacheTemplate)(title, data);
};
exports.customizeGroupName = customizeGroupName;
//# sourceMappingURL=customizeGroupName.js.map